import {defineStore} from "pinia";
import axios from "axios";

const IResult = {
    persons: [],
    organisations: [],
    locations: [],
    summary: ""
};

export const useStore = defineStore({
    id: "store",
    state: () => ({
        notifications: [],
        bookmarkList: [],
        activeBookMark: null,
        isPageLoading: false,
        isNerLoading: false
    }),
    actions: {
        createNotify(mess, type) {
            this.notifications.push({
                message: mess,
                type: type,
                color: type === "success" ? "green" : "red",
                lifeTime: type === "success" ? 5000 : 5000
            });
        },
        async createNer(text, prompt, title = null, language = "ru") {
            this.isNerLoading = true;
            try {
                const { data } = await axios.post("/ner/items/", {
                    title: title,
                    text: text,
                    prompt: prompt,
                    language: language
                });
                this.createNotify("Текст отправлен на анализ", "success");
                return await this.getNer(data.id);
            } catch (e) {
                console.log("error", e);
                this.createNotify("Ошибка сервера при анализе текста", "error");
                return IResult;
            }
        },
        async getNer(id){
            try {
                const {data, status} = await axios.get(`/ner/items/${id}`);

                // Если текст еще не обработан - повторный вызов.
                if (status === 204) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                    return await this.getNer(id);
                }
                this.createNotify("Анализ текста получен", "success");
                this.isNerLoading = false;
                // Моковые данные для тестов
                // return {"persons": ["вузов", "регионе"], "locations": ["России", "Китая"],
                // "organisations": ["АмурЭкспоФорум"]};
                return data;
            } catch (e) {
                console.log("error", e);
                this.createNotify("Ошибка сервера при получение анализа текста", "error");
                this.isNerLoading = false;
                return IResult;
            }
        }
    }
});